import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const DIR_VACIA = { direccion: "", comuna: "", ciudad: "", esPorDefecto: false };

function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nombre: "", apellido: "", rut: "", email: "", telefono: "",
    username: "", password: "",
  });
  const [direcciones, setDirecciones] = useState([
    { ...DIR_VACIA, esPorDefecto: true },
  ]);
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleDirCampo = (idx, e) =>
    setDirecciones(prev =>
      prev.map((d, i) => i === idx ? { ...d, [e.target.name]: e.target.value } : d)
    );

  const marcarDefault = (idx) =>
    setDirecciones(prev => prev.map((d, i) => ({ ...d, esPorDefecto: i === idx })));

  const agregarDireccion = () =>
    setDirecciones(prev => [...prev, { ...DIR_VACIA }]);

  const eliminarDireccion = (idx) =>
    setDirecciones(prev => {
      const nueva = prev.filter((_, i) => i !== idx);
      if (prev[idx].esPorDefecto && nueva.length > 0) {
        nueva[0] = { ...nueva[0], esPorDefecto: true };
      }
      return nueva;
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!direcciones.some(d => d.esPorDefecto)) {
      setError("Debes marcar una dirección como principal.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/register`, { ...form, direcciones });
      alert("Cuenta creada correctamente. Ahora puedes iniciar sesión.");
      navigate("/login");
    } catch (err) {
      setError(err.response?.data?.error || "Error al registrar. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={st.container}>
      <h2 style={st.titulo}>Crear Cuenta</h2>
      {error && <p style={st.error}>{error}</p>}

      <form onSubmit={handleSubmit} style={st.form}>

        {/* ── Datos personales ── */}
        <fieldset style={st.fieldset}>
          <legend style={st.legend}>Datos personales</legend>
          <div style={st.fila}>
            <Campo label="Nombre *" name="nombre" value={form.nombre} onChange={handleChange} required />
            <Campo label="Apellido *" name="apellido" value={form.apellido} onChange={handleChange} required />
          </div>
          <Campo label="RUT * (ej: 12345678-9)" name="rut" value={form.rut}
            onChange={handleChange} placeholder="12345678-9" required />
          <div style={st.fila}>
            <Campo label="Email *" name="email" type="email" value={form.email} onChange={handleChange} required />
            <Campo label="Teléfono *" name="telefono" type="tel" value={form.telefono}
              onChange={handleChange} placeholder="+56 9 1234 5678" required />
          </div>
        </fieldset>

        {/* ── Direcciones ── */}
        <fieldset style={st.fieldset}>
          <legend style={st.legend}>Direcciones de envío</legend>

          {direcciones.map((dir, idx) => (
            <div key={idx} style={st.tarjetaDir}>
              <div style={st.tarjetaHeader}>
                <span style={st.numDir}>Dirección {idx + 1}</span>
                {dir.esPorDefecto
                  ? <span style={st.badgePrincipal}>Principal</span>
                  : (
                    <button type="button" onClick={() => marcarDefault(idx)} style={st.btnDefault}>
                      Marcar como principal
                    </button>
                  )
                }
                {direcciones.length > 1 && (
                  <button type="button" onClick={() => eliminarDireccion(idx)} style={st.btnX}>✕</button>
                )}
              </div>

              <Campo label="Dirección *" name="direccion" value={dir.direccion}
                onChange={e => handleDirCampo(idx, e)} required />
              <div style={{ ...st.fila, marginTop: 8 }}>
                <Campo label="Comuna *" name="comuna" value={dir.comuna}
                  onChange={e => handleDirCampo(idx, e)} required />
                <Campo label="Ciudad *" name="ciudad" value={dir.ciudad}
                  onChange={e => handleDirCampo(idx, e)} required />
              </div>
            </div>
          ))}

          <button type="button" onClick={agregarDireccion} style={st.btnAgregar}>
            ➕ Agregar dirección
          </button>
        </fieldset>

        {/* ── Acceso ── */}
        <fieldset style={st.fieldset}>
          <legend style={st.legend}>Acceso</legend>
          <Campo label="Nombre de usuario *" name="username" value={form.username} onChange={handleChange} required />
          <Campo label="Contraseña *" name="password" type="password"
            value={form.password} onChange={handleChange} required minLength={4} />
        </fieldset>

        <button type="submit" style={st.boton} disabled={loading}>
          {loading ? "Registrando..." : "Crear cuenta"}
        </button>

        <p style={{ textAlign: "center", marginTop: 12 }}>
          ¿Ya tienes cuenta? <a href="/login">Inicia sesión</a>
        </p>
      </form>
    </div>
  );
}

function Campo({ label, name, type = "text", value, onChange, placeholder, required, minLength }) {
  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={{ fontSize: 13, color: "#444" }}>{label}</label>
      <input
        name={name} type={type} value={value} onChange={onChange}
        placeholder={placeholder || ""} required={required} minLength={minLength}
        style={{ padding: "8px 10px", borderRadius: 4, border: "1px solid #ccc", width: "100%", boxSizing: "border-box" }}
      />
    </div>
  );
}

const st = {
  container: { maxWidth: 580, margin: "40px auto", padding: "0 16px" },
  titulo:    { textAlign: "center", marginBottom: 24 },
  form:      { display: "flex", flexDirection: "column", gap: 20 },
  fieldset:  { border: "1px solid #ddd", borderRadius: 8, padding: "16px 20px" },
  legend:    { fontWeight: "bold", padding: "0 8px" },
  fila:      { display: "flex", gap: 16 },
  tarjetaDir:{
    border: "1px solid #e5e7eb", borderRadius: 6, padding: 12,
    marginBottom: 12, backgroundColor: "#fafafa",
    display: "flex", flexDirection: "column", gap: 6,
  },
  tarjetaHeader: { display: "flex", alignItems: "center", gap: 8 },
  numDir:    { fontWeight: 600, fontSize: 13 },
  badgePrincipal:{
    backgroundColor: "#1a1a2e", color: "#fff",
    fontSize: 11, padding: "2px 10px", borderRadius: 10,
  },
  btnDefault:{
    fontSize: 11, padding: "2px 10px", border: "1px solid #bbb",
    borderRadius: 10, cursor: "pointer", background: "#f5f5f5", color: "#444",
  },
  btnX:{
    marginLeft: "auto", background: "none", border: "none",
    color: "#dc2626", cursor: "pointer", fontSize: 16, lineHeight: 1, padding: 0,
  },
  btnAgregar:{
    padding: "7px 16px", background: "#f5f5f5", border: "1px solid #ddd",
    borderRadius: 6, cursor: "pointer", fontSize: 13, marginTop: 4, alignSelf: "flex-start",
  },
  boton:{
    padding: "12px 0", backgroundColor: "#1a1a2e", color: "#fff",
    border: "none", borderRadius: 8, fontSize: 16, cursor: "pointer",
  },
  error: { color: "red", textAlign: "center", marginBottom: 8 },
};

export default Register;
